<div class="app-info-page__container">
  <div class="app-info-card">
    <h2>Informations sur l'application</h2>
    
    <div class="info-row">
      <span class="label">Version de l'application :</span>
      <span class="value">{{ appVersion }}</span>
    </div>

    <div class="info-row" *ngIf="envVersion">
      <span class="label">Version de l'environnement de {{envType}} :</span>
      <span class="value">{{ envVersion }}</span>
    </div>

    <div class="info-row" *ngIf="dateMAJ">
      <span class="label">Dernière mise à jour :</span>
			<span class="value">{{ dateMAJ | date: 'dd/MM/yyyy à HH:mm' }}</span>
    </div>
  </div>
</div>
